var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-card",class:{
    inverted: _vm.inverted,
    compact: _vm.compact,
    'minimal-vertical-padding': _vm.minimalVerticalPadding,
    'top-shadow': _vm.topShadow,
    'full-height': _vm.fullHeight,
    'no-border-radius': _vm.noBorderRadius,
    'no-vertical-padding': _vm.noVerticalPadding,
    'no-padding': _vm.noPadding,
    transparent: _vm.transparent,
    'has-background-image': _vm.backgroundImage !== undefined,
  },style:({
    color: _vm.textColor,
    backgroundColor: _vm.backgroundColor,
    'background-image': _vm.currentBackgroundImage
      ? `url('${_vm.currentBackgroundImage}')`
      : undefined,
    'border-top-left-radius': _vm.borderTopRadius,
    'border-top-right-radius': _vm.borderTopRadius,
    'border-bottom-left-radius': _vm.borderBottomRadius,
    'border-bottom-right-radius': _vm.borderBottomRadius,
  }),on:{"click":e => this.$emit('click', e)}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }